import Vue from 'vue';
import VueRouter from 'vue-router';

import Auth from '@/services/auth';
import { events as alert } from '@/plugins/capusta_alert/events';

import routes from './routes';
import middlewarePipeline from './middlewarePipeline';

import store from '../store';

import {
  CABINET,
  PROJECTS,
  PARTNERS,
  PROFILE,
  IDENTITY,
  TWO_FACTOR,
  SELF_EMPLOYED,
  TIMEZONE
} from './const';

Vue.use(VueRouter);

const router = new VueRouter({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

const PARTNER_PERMISSIONS = [
  CABINET,
  PROJECTS,
  PARTNERS,
  PROFILE,
  IDENTITY,
  TWO_FACTOR,
  SELF_EMPLOYED,
  TIMEZONE,
  'projectCreate',
];

// TODO: @danealton вынести эти проверки на сторону страниц
// eslint-disable-next-line complexity
function checkRoutePermission(to, from, next) {
  const getters = store.getters;

  if (getters.merchantIsInactive) {
    next({ name: 'login' });
  } else if (getters.userProjectIsInactive) {
    if (to.name === 'cabinet') {
      next();
    } else {
      next({ name: 'cabinet' }); // пускаем только в кабинет

      alert.$emit('show', {
        type: 'warning',
        text: 'alert.denied.action',
      });
    }
  } else if (getters.isEmptyCurrency) {
    if (['projectCreate', 'projects', 'partners'].includes(to.name)) {
      next();
    } else {
      next({ name: 'project.currency' });
    }
  } else if (getters.isPartnerProject) {
    if (PARTNER_PERMISSIONS.includes(to.name)) {
      next();
    } else {
      next({ name: 'cabinet' }); // пускаем только в кабинет
    }
  } else if (to.name === 'subscriptions') {
    if (getters.isShownSubscriptions) {
      next();
    } else {
      next({ name: 'cabinet' });
    }
  } else {
    // TODO: все вышенаписанное в этом методе должно быть вынесено в промежуточные обработчики
    if (!to.meta.middleware) {
      return next();
    }

    const middleware = to.meta.middleware;
    const context = { to, from, next, store };

    return middleware[0]({
      ...context,
      next: middlewarePipeline(context, middleware, 1),
    });
  }
}

// store.dispatch("APP_INIT_LOAD") возвращает промис после выполнения.
// Если мерчант заблокирован, блокируем ему весь кабинет, кроме страниц, кот. не требуют
// регистрации.
// Если проект заблокирован, пускаем только в кабинет
router.beforeEach((to, from, next) => {
  const { query } = to;

  if (query.token && Object.keys(query).length === 1) {
    Auth.authByToken(query.token);
    return;
  }

  // fix: CPME-4302
  if (from.path === to.path) {
    return;
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Auth.checkAuth()) {
      localStorage.setItem('redirect', to.path);
      next({ name: 'login' });
    } else {
      localStorage.removeItem('redirect');

      store.dispatch('APP_INIT_LOAD').then(() => {
        checkRoutePermission(to, from, next);
      });
    }
  } else {
    next();
  }
});

export default router;
